import { render, staticRenderFns } from "./ContentPasteIcon.vue?vue&type=template&id=f218af74&scoped=true&"
import script from "./ContentPasteIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ContentPasteIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f218af74",
  null
  
)

export default component.exports